"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const merge_1 = __importDefault(require("lodash/merge"));
const query_string_1 = __importDefault(require("query-string"));
const set_1 = __importDefault(require("lodash/set"));
const config = __importStar(require("./configs"));
const { TYPES: CONFIG_BY_PATH, PARAMS: CONFIG_BY_QUERYPARAMS } = config;
function getConfigByPathName(pathname, config) {
    return Object.keys(config).reduce((acc, name) => {
        const { check, payload } = config[name];
        if (check.test(pathname)) {
            return (0, merge_1.default)(acc, payload);
        }
        return acc;
    }, {});
}
/**
 * Принимает набор get-параметров в виде объекта и конфиг для обработки get-параметров.
 * В кинфиге описан набор возможных get-параметров,
 * которые могут быть обработаны и добавлены в основной конфиг приложения
 *
 * @param {object} queryParams - набор get-параметров в виде объекта
 * @param {object} paramsModel - конфиг для обработки get-параметров
 *
 * @returns {object}
 */
function getConfigByParams(queryParams, paramsModel) {
    // eslint-disable-next-line max-statements, complexity
    return Object.keys(queryParams).reduce((acc, name) => {
        if (paramsModel[name]) {
            const { type, path } = paramsModel[name];
            const value = queryParams[name];
            if (type === 'boolean') {
                // eslint-disable-next-line max-depth
                if (value === '1' || value === 'true') {
                    (0, set_1.default)(acc, path, true);
                }
                // eslint-disable-next-line max-depth
                if (value === '0' || value === 'false') {
                    (0, set_1.default)(acc, path, false);
                }
            }
            if (type === 'string') {
                (0, set_1.default)(acc, path, value);
            }
        }
        return acc;
    }, {});
}
function getConfigByContent({ isHaveUxQuestions }) {
    if (isHaveUxQuestions) {
        return {
            theme: 'ux',
            footer: { enable: false },
            pagination: { enable: true },
            progressBar: { enable: false }
        };
    }
    return {};
}
function getConfigByHost(host) {
    if (host.startsWith(`l7test.yandex.`)) {
        return {
            metrika: 42616079
        };
    }
    if (host.startsWith(`preview`) || host.startsWith(`pythia-demo-test.`)) {
        return {
            localStorage: {
                enable: false
            },
            metrika: 42616079
        };
    }
    return {};
}
function getConfig({ host, pathname, search, isHaveUxQuestions }) {
    const queryParams = query_string_1.default.parse(search);
    return (0, merge_1.default)({}, CONFIG, getConfigByHost(host), getConfigByPathName(pathname, CONFIG_BY_PATH), getConfigByParams(queryParams, CONFIG_BY_QUERYPARAMS), getConfigByContent({ isHaveUxQuestions }));
}
exports.default = getConfig;
